<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <div class="top-wrapper">
      <div class="top-list">机内票数：{{num}}张</div>
      <div class="top-list top-list2">
        <p>
          <span :class="{'active':cur}" @click="cur=!cur"></span>监控机内票数
        </p>
        <p>
          <span class="icon" @click="dPageSize"></span>
          <input type="text" v-model="pageSize" @input="setPageSize" @focus="setPages" />
          <span class="icon iconAdd" @click="addPageSize"></span>张时，页面下方提示。
        </p>
      </div>
      <div class="top-list">
        <p>
          当前剩余{{ynum}}/{{num}}张
          <span class="icon" @click="desYnum"></span>
          <input type="text" v-model="ynum" @input="setYnum" @focus="setYnumInput" />
          <span class="icon iconAdd" @click="addYnum"></span>
        </p>
      </div>
      <div class="btn btn-group">
        <div class="ok" @click="setPage">确定</div>
        <div class="cancel" @click="resSet">重设初始数量</div>
      </div>
    </div>
    <div class="item">
      <div class="row">
        <span @click="getNum('1')">1</span>
        <span @click="getNum('2')">2</span>
        <span @click="getNum('3')">3</span>
      </div>
      <div class="row">
        <span @click="getNum('4')">4</span>
        <span @click="getNum('5')">5</span>
        <span @click="getNum('6')">6</span>
      </div>
      <div class="row">
        <span @click="getNum('7')">7</span>
        <span @click="getNum('8')">8</span>
        <span @click="getNum('9')">9</span>
      </div>
      <div class="row">
        <span @click="delelteNum">
          <i class="iconfont iconshanchu"></i>
        </span>
        <span @click="getNum('0')">0</span>
        <span
          @click="getSend"
          :disabled="qrcode.length>=8?false:true"
          :class="{'active':qrcode.length>=8}"
        >
          <i class="iconfont iconquerenduigougouhao"></i>
        </span>
      </div>
    </div>
    <div class="back" @click="goBack">退出</div>

    <div class="footer">
      <p>
        <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850 25650860</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { setInterval, clearInterval, setTimeout } from "timers";
export default {
  name: "HelloWorld",
  data() {
    return {
      deviceId: localStorage.deviceNum || "123456789",
      time: "",
      today: "",
      day: "",
      timer: "",
      week: "",
      times: 60,
      qrcode: "",
      num: 22,
      cur: true,
      pageSize: 18,
      ynum: 0,
      ynumF: false,
      pageF: false
    };
  },
  created() {
    var that = this;
    var obj = jsObj.getPageStatus();
    this.num = Number(obj.split(",")[0]);
    this.ynum = Number(obj.split(",")[1]);
    this.pageSize = Number(obj.split(",")[2]);
  },
  mounted() {
    this.getDay();
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    setYnumInput() {
      this.ynumF = true;
      this.pageF = false;
    },
    setPages() {
      this.pageF = true;
      this.ynumF = false;
    },
    resSet() {
      var obj = jsObj.getPageStatus();
      this.num = Number(obj.split(",")[0]);
      this.ynum = Number(obj.split(",")[1]);
      this.pageSize = Number(obj.split(",")[2]);
    },
    setYnum() {
      this.ynum = this.ynum > this.num ? this.num : this.ynum;
    },
    setPageSize() {
      this.pageSize = this.pageSize > this.num ? this.num : this.pageSize;
    },
    //删除
    delelteNum() {
      if (this.ynumF) {
        this.ynum = this.ynum.toString();
        this.ynum = this.ynum.substring(0, this.ynum.length - 1);
        this.ynum = this.ynum.length == 0 ? 0 : Number(this.ynum);
      }
      if (this.pageF) {
        this.pageSize = this.pageSize.toString();

        this.pageSize = this.pageSize.substring(0, this.pageSize.length - 1);
        this.pageSize = this.pageSize.length == 0 ? 1 : Number(this.pageSize);
      }
    },
    getNum(num) {
      if (this.ynumF) {
        this.ynum += num;
        this.ynum = Number(this.ynum);
      }
      if (this.pageF) {
        if (Number(this.pageSize) < this.ynum) {
          this.pageSize += num;
          this.pageSize =
            Number(this.pageSize) > this.ynum
              ? this.ynum
              : Number(this.pageSize);
        }
      }
    },
    goBack() {
      this.$router.replace("/buy");
    },
    // 设置纸张提示函数
    addPageSize() {
      if (this.pageSize < this.ynum) {
        this.pageSize = this.pageSize + 1;
      }
    },
    addYnum() {
      this.ynum = this.ynum + 1;
    },
    desYnum() {
      if (this.ynum > 2) {
        this.ynum = this.ynum - 1;
      }
    },
    dPageSize() {
      if (this.pageSize >= 2) {
        this.pageSize = this.pageSize - 1;
      }
    },
    //设置密码
    getSend() {
      this.pageSize = this.pageSize.toString();
      this.ynum = this.ynum.toString();
      jsObj.setPageStatus(this.pageSize, this.ynum);
      this.$router.replace("/");
    },
    setPage() {
      this.pageSize = this.pageSize.toString();
      this.ynum = this.ynum.toString();

      jsObj.setPageStatus(this.pageSize, this.ynum);
      this.$router.replace("/");
    },
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      var weeks = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          weeks = "周日";
          break;
        case 1:
          strWeek = "星期一";
          weeks = "周一";
          break;
        case 2:
          strWeek = "星期二";
          weeks = "周二";
          break;
        case 3:
          strWeek = "星期三";
          weeks = "周三";
          break;
        case 4:
          strWeek = "星期四";
          weeks = "周四";
          break;
        case 5:
          strWeek = "星期五";
          weeks = "周五";
          break;
        case 6:
          strWeek = "星期六";
          weeks = "周六";
          break;
      }
      this.time = hours + ":" + min;
      this.day = month + "月" + days + "日 ";
      this.today = month + "月" + days + "日 " + strWeek;
      this.week = weeks;
    },
    goBack() {
      this.$router.replace("/");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  height: 1920px;
  background: #f0f0f0;
  overflow: hidden;
  .top {
    padding: 68px 50px;
    color: #4d4d4d;
    font-size: 25px;
    position: relative;
    h3 {
      font-size: 70px;
      margin: 0;
    }
    .title {
      position: absolute;
      top: 100px;
      left: 55%;
      transform: translateX(-50%);
      font-size: 50px;
      font-weight: 500;
      letter-spacing: 3px;
    }
  }
  .titles {
    font-size: 60px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: left;
    margin: 85px 60px 50px;
  }
}
// 头部列表样式
.top-wrapper {
  padding: 100px 155px 30px;
  .top-list {
    height: 144px;
    font-size: 30px;
    line-height: 144px;
    background: #fff;
    border-radius: 20px;
    padding: 0 82px;
    margin-bottom: 25px;
    p {
      input {
        height: 70px;
        width: 98px;
        border-radius: 35px;
        outline: 0 none;
        text-align: center;
        border: 0 none;
        display: inline-block;
        margin: 0 10px;
        background: #e8e8e8;
        color: #818181;
        font-size: 30px;
      }
      .icon {
        width: 40px;
        height: 40px;
        display: inline-block;
        background: url(.././assets/p.png) no-repeat;
        background-size: cover;
        vertical-align: middle;
        margin: 0 5px;
        &.iconAdd {
          background: url(.././assets/add.png) no-repeat;
          background-size: cover;
        }
      }
    }
  }
  .top-list2 {
    height: auto;
    padding-bottom: 45px;
    p {
      line-height: 51px;
      input {
        height: 70px;
        width: 98px;
        border-radius: 35px;
        outline: 0 none;
        text-align: center;
        border: 0 none;
        display: inline-block;
        margin: 0 10px;
        background: #e8e8e8;
        color: #818181;
        font-size: 30px;
      }
      .icon {
        width: 40px;
        height: 40px;
        display: inline-block;
        background: url(.././assets/p.png) no-repeat;
        background-size: cover;
        vertical-align: middle;
        margin: 0 5px;
        &.iconAdd {
          background: url(.././assets/add.png) no-repeat;
          background-size: cover;
        }
      }
      &:first-child {
        margin-bottom: 50px;
        line-height: 51px;
        padding-top: 45px;
        span {
          display: inline-block;
          width: 84px;
          height: 51px;
          background: url(.././assets/noopen.png) no-repeat;
          cursor: pointer;
          background-size: cover;
          margin-right: 20px;
          vertical-align: middle;
          &.active {
            background: url(.././assets/open.png) no-repeat;
            background-size: cover;
          }
        }
      }
    }
  }
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all ease-in-out 300ms;
  .mask-content {
    width: 600px;
    height: 384px;
    background: #fff;
    border-radius: 6px;
    padding: 65px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .icon {
      width: 102px;
      height: 102px;
      background: url(.././assets/icon.png) no-repeat;
      background-size: cover;
      margin: 0 auto 80px;
    }
    p {
      color: #5c5c5c;
      font-size: 30px;
      text-align: center;
    }
  }
}
.item {
  width: 650px;
  margin: 0 auto;
  border-radius: 6px;
  background-size: cover;
  &:first-child {
    margin-right: 60px;
    width: 390px;
    background-size: cover;
  }
  h3 {
    text-align: center;
    margin: 80px 0 60px;
    color: #005192;
    font-size: 40px;
    letter-spacing: 4px;
  }
  p {
    margin-top: 10px;
    text-align: center;
    color: #010101;
    font-size: 26px;
    line-height: 36px;
    width: 184px;
    margin: 0 auto;
    &.des {
      color: #8e8e8e;
      font-size: 30px;
    }
  }
  .img-qu {
    display: block;
    margin: 65px auto;
  }
  .input-wrapper {
    width: 540px;
    margin: 60px auto;
    height: 100px;
    border-radius: 50px;
    background: #cccccc;
    padding: 20px 30px;
    input {
      border: 0 none;
      outline: 0 none;
      display: block;
      width: 420px;
      margin: 10px auto;
      background: #cccccc;
      height: 40px;
      line-height: 40px;
      font-size: 38px;
      color: #434343;
      letter-spacing: 2px;
      text-align: center;
    }
  }
  .row {
    margin: 30px auto;
    width: 540px;
    span {
      width: 114px;
      height: 114px;
      display: inline-block;
      background: #ccc;
      border-radius: 50%;
      line-height: 114px;
      text-align: center;
      color: #434343;
      font-size: 48px;
      &:nth-child(2) {
        margin-left: 89.5px;
        margin-right: 89.5px;
      }
      &.active {
        background: #b95020;
        i {
          color: #fff;
        }
      }
      i {
        font-size: 48px;
        &.iconshanchu {
          display: inline-block;
          font-size: 30px;
          margin-top: -12px;
          vertical-align: middle;
        }
      }
    }
  }
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  top: 35%;
  right: 0;
  z-index: 998;
  font-weight: 500;
}
.btn-group {
  padding: 50px 0 0;
  .ok {
    width: 335px;
    height: 98px;
    background: rgba(185, 80, 32, 1);
    border-radius: 49px;
    line-height: 98px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    margin-right: 95px;
    font-size: 30px;
  }
  .cancel {
    width: 335px;
    height: 98px;
    background: rgba(232, 232, 232, 1);
    border-radius: 49px;
    line-height: 98px;
    color: #494949;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    font-size: 30px;
  }
}
.footer {
  position: fixed;
  bottom: 0;
  padding: 60px;
  font-size: 24px;
  width: 100%;
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page.vue